export const vertexShader = `
  varying vec2 vUv;
  uniform float u_offset;
  uniform float u_alpha;
  uniform float u_target_offset;

  void main() {
    vUv = uv;
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;
  }
`

// export const fragmentShader = `
//   uniform sampler2D map;

//   void main()
//   {
//     gl_FragColor = texture2D(map, uv);
//   }
// `;

// gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);

export const fragmentShader = `
  varying vec2 vUv;
  uniform sampler2D u_texture;
  uniform float u_offset;
  uniform float u_alpha;
  uniform float u_target_offset;

  void main()
  {
    float x = vUv.x > u_offset ? float(((1.0 - u_offset) * 0.25) + 0.25 + 0.032) : float((1.0 - u_offset) * 0.25 + 0.032);
    vec2 uv = vec2(0.5, 1.0) * vUv + vec2(x, 0.0);
    gl_FragColor = texture2D(u_texture, uv);
    float alpha = 1.0;
    if(u_offset > 0.505 && uv.x > u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 + u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      gl_FragColor.a = alpha;
    }

    if(u_offset < 0.495 && uv.x < u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 - u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      gl_FragColor.a = alpha;
    }
  }
`

export const fragmentShaderSilverado = `
  varying vec2 vUv;
  uniform sampler2D u_texture;
  uniform float u_offset;
  uniform float u_alpha;
  uniform float u_target_offset;

  void main()
  {
    float x = vUv.x > u_offset ? float(((1.0 - u_offset) * 0.25) + 0.25 + 0.018) : float((1.0 - u_offset) * 0.25 - 0.018);
    vec2 uv = vec2(0.5, 1.0) * vUv + vec2(x, 0.0);
    gl_FragColor = texture2D(u_texture, uv);
    float alpha = 1.0;
    if(u_offset > 0.505 && uv.x > u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 + u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      gl_FragColor.a = alpha;
    }

    if(u_offset < 0.495 && uv.x < u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 - u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      gl_FragColor.a = alpha;
    }
  }
`

export const fragmentVerticalShader = `
  varying vec2 vUv;
  uniform sampler2D u_texture;
  uniform float u_offset;
  uniform float u_alpha;
  uniform float u_target_offset;

  void main()
  {
    float x = vUv.y > u_offset ? float(0.3418 / 2.0 - 0.0125) : float(0.3418 / 2.0 + 0.5);
    float y = vUv.y > u_offset ? float((1.0 - u_offset) * 0.5 - 0.25) : float((1.0 - u_offset) * 0.5);
    vec2 uv = vec2(0.3164 / 2.0, 1.0) * vUv + vec2(x, y);
    gl_FragColor = texture2D(u_texture, uv);
    float alpha = 1.0;
    if(u_offset > 0.505 && uv.x < u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 + u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      if (u_offset > 0.6) alpha = 1.0;
      gl_FragColor.a = alpha;
    }

    if(u_offset < 0.495 && uv.x > u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 - u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      if (u_offset < 0.4) alpha = 1.0;
      gl_FragColor.a = alpha;
    }
  }
`
export const fragmentVerticalShaderSilverado = `
  varying vec2 vUv;
  uniform sampler2D u_texture;
  uniform float u_offset;
  uniform float u_alpha;
  uniform float u_target_offset;

  void main()
  {
    float x = vUv.y > u_offset ? float(0.3418 / 2.0 - 0.0125) : float(0.3418 / 2.0 + 0.5);
    float y = vUv.y > u_offset ? float((1.0 - u_offset) * 0.5 - 0.25 - 0.275) : float((1.0 - u_offset) * 0.5 + 0.05);
    vec2 uv = vec2(0.3164 / 2.0, 1.0) * vUv + vec2(x, y);
    gl_FragColor = texture2D(u_texture, uv);
    float alpha = 1.0;
    if(u_offset > 0.505 && uv.x < u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 + u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      if (u_offset > 0.6) alpha = 1.0;
      gl_FragColor.a = alpha;
    }

    if(u_offset < 0.495 && uv.x > u_offset) {
      alpha = 1.0 - (0.5 - u_offset)/(0.5 - (0.5 - u_target_offset)) * (1.0 - u_alpha);
      if (alpha < 1.0 - u_alpha) alpha = 1.0 - u_alpha;
      if (u_offset < 0.4) alpha = 1.0;
      gl_FragColor.a = alpha;
    }
  }
`

// float x = vUv.x > u_offset ? float(((1.0 - u_offset) * 0.25) + 0.25 + 0.018) : float((1.0 - u_offset) * 0.25 - 0.018);

/* VERTEX

  mediump vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
  gl_Position = projectionMatrix * mvPosition;

*/

// + uvOffset;
// vec2 uv = vec2(0.5, 0.5) * vUv + uvOffset;
// vec2 uv = vec2(0.5, 0.5) * vUv
// outColor = texture2D(map, uv);

// vec2 texcoord = vec2(0.5, 0.5);
// outColor = texture(u_texture, texcoord);
